export default __webpack_public_path__ + "static/media/logo_branco.8c1840ee.png";